export const ACTION_ADD = 'add';
export const ACTION_FETCH = 'fetch';
export const STORE_MODULE_NAME = 'organization-reviews';



// WEBPACK FOOTER //
// ./src/pages/organizations/card/reviews/const.ts